import {
  gridSizeMdLg2,
  gridSizeMdLg12,
  gridSizeMdLg4,
  formatDate,
  hasPermission,
} from "@/shared"
import { IDataMovimientoInventario, IDataProducto } from "@/shared/interfaces"
import { Button, Grid } from "@mui/material"
import { BODEGAS, Ubicaciones, UbicacionesParams } from "@/shared/interfaces/erp/inventario"
import { GeneralTable } from "@/shared/components/ui"
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm"
import DateRangePicker from "@/shared/components/ui/CustomSearch/DateRangePicker"
import { Refresh, Search } from "@mui/icons-material"
import DeleteIcon from '@mui/icons-material/Delete';
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch"
import useKardexByBodega from "../hook/useKardeByBodega"
import { useMemo } from "react"
import { PermissionsEnum } from "@/auth/interfaces"
import { PiMicrosoftExcelLogoFill } from "react-icons/pi"
import ExcelDownloadLoader from "@/shared/components/ui/ExcelDownloadLoader/ExcelDownloadLoader"

export default function KardexPorBodega() {


  const {
    form,
    setEnabled,
    enabled,
    bodega,
    flatpickrRef,
    setFilterObject,
    columnBase,
    dataKardex,
    isLoadingKardex,
    isRefetchingKardex,
    pagination,
    setPagination,
    columnFilters,
    setColumnFilters,
    downloadKardexExcel,
    refetch
  } = useKardexByBodega()

  const {
    control,
    reset
  } = form

  const {
    fetchAutocompleteBodega,
    fetchAutocompleteUbicacion,
    fetchAutocompleteProducto
  } = useAutocompleteFetch()

  const paramsUbicaciones = useMemo<UbicacionesParams>(
    () => ({
      bodega
    }),
    [bodega]
  );



  return (
    <>
    <Grid container spacing={3}
      justifyContent={'end'}
    //alignItems={'center'}
    >


      <Grid item
        container
        {...gridSizeMdLg12}
        spacing={3}>

        <CustomAutocompleteFetchForm<BODEGAS>
          required={false}
          control={control}
          size={gridSizeMdLg4}
          name="bodega_origen_o_destino"
          label="Bodega"
          fetchData={fetchAutocompleteBodega}
          isAll
          getOptionLabel={(opt) => opt.nombre || ''}
          key={'bodega_origen_o_destino'}
          getOptionKey={(o) => o.codigo!}
          onChangeValue={(e) => {
            setEnabled(false);
            reset({
              ...form.getValues(),
              bodega_origen_o_destino: e as string,
              ubicacion_origen_o_destino: null,
            })


          }}
        />

        <CustomAutocompleteFetchForm<Ubicaciones>
          required={false}
          disabled={!bodega}
          control={control}
          size={gridSizeMdLg4}
          isAll
          name="ubicacion_origen_o_destino"
          label="Ubicación"
          fetchParams={paramsUbicaciones}
          fetchData={fetchAutocompleteUbicacion}
          getOptionLabel={(opt) => opt.nombre || ''}
          key={'ubicacion_origen_o_destino'}
          getOptionKey={(o) => o.codigo!}
          onChangeValue={(e) => {
            setEnabled(false);
            form.setValue('ubicacion_origen_o_destino', e as string);
          }}
        />

        <DateRangePicker
          size={gridSizeMdLg4}
          flatpickrRef={flatpickrRef}
          defaultValue={[form.getValues().fecha_creacion_after, form.getValues().fecha_creacion_before]}
          onChange={(range) => {
            console.log(range);
            setEnabled(false);

            if (range.length == 2) {
              reset({
                ...form.getValues(),
                fecha_creacion_after: formatDate(range[0]),
                fecha_creacion_before: formatDate(range[1])
              })

            }

          }}
        />


        <CustomAutocompleteFetchForm<IDataProducto>
          control={control}
          required={false}
          size={gridSizeMdLg4}
          name="producto"
          label="Codigo producto"
          fetchData={fetchAutocompleteProducto}
          keySearch="codigo"
          getOptionLabel={(opt) => `${opt.codigo}` || ''}
          key={'autocomplete-producto'}
          getOptionKey={(opt) => opt.codigo}
          onChangeValue={() => {
            setEnabled(false);
          }}
        />

        <CustomAutocompleteFetchForm<IDataProducto>
          control={control}
          required={false}
          size={gridSizeMdLg4}
          name="descripcion_producto"
          label="Descripción producto"
          fetchData={fetchAutocompleteProducto}
          keySearch="descripcion"
          getOptionLabel={(opt) => `${opt.descripcion}` || ''}
          key={'autocomplete-producto'}
          getOptionKey={(opt) => opt.descripcion}
          //isAll={true}
          onChangeValue={() => {
            setEnabled(false);

          }}
        />

      </Grid>


      <Grid item {...gridSizeMdLg2}>
        <Button
          fullWidth
          size="small"
          variant="contained"
          startIcon={<Search />}
          onClick={() => {

            reset({
              ...form.getValues(),
              estado: true
            })

            setEnabled(true)
          }}
        >
          Buscar
        </Button>
      </Grid>

      <Grid item {...gridSizeMdLg2}>
        <Button
          fullWidth
          size="small"
          variant="outlined"
          startIcon={<DeleteIcon />}
          onClick={() => {
            reset({
              estado: false
            })
            setFilterObject({})

            setEnabled(false)

            flatpickrRef.current?.flatpickr.clear();

          }}
        >
          Limpiar
        </Button>




      </Grid>

      <Grid item {...gridSizeMdLg2}>
        <Button
          fullWidth
          size="small"
          variant="outlined"
          startIcon={<Refresh />}
          onClick={() => {
            refetch()
          }}
        >
          Actualizar
        </Button>
      </Grid>
      {
        hasPermission(PermissionsEnum.reporte_stock_actual_descargar_excel) &&
        <Grid item {...gridSizeMdLg2}>
          <Button
            fullWidth
            size="small"
            startIcon={<PiMicrosoftExcelLogoFill />}
            variant="contained"
            color="success"
            onClick={() => {
              downloadKardexExcel()
            }}
          >
            EXCEL
          </Button>
        </Grid>
      }
      <Grid item {...gridSizeMdLg12}>

        <GeneralTable<IDataMovimientoInventario>
          columns={columnBase}
          data={enabled
            ? dataKardex?.data.data || []
            : []}
          //
          isLoading={isLoadingKardex}
          isRefetching={isRefetchingKardex}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={dataKardex?.data?.count}
          // // actions
          actionsColumnSize={120}

          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          enableColumnActions={true}

          // crud
          enableEditing={false}
          positionActionsColumn='first'
        />
      </Grid>

    </Grid>

    </>
  )

}